import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	padding: 20px;
	.report-box {
		padding: 50px 30px;
		border-radius: 10px;
		background: #000;
		color: #fff;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-top: 20px;
		.title {
			font-weight: bold;
			font-size: 16px;
			margin-bottom: 20px;
		}
		.price {
			font-size: 20px;
			.currency {
				opacity: 0.7;
				font-size: 15px;
			}
		}
		&.report-by-tags {
			padding: 15px 20px;
			.report-item {
				display: flex;
				width: 100%;
				align-items: center;
				justify-content: space-between;
				&:not(:last-child) {
					margin-bottom: 15px;
				}
			}
		}
	}
`;
